import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import { collection, getDocs, updateDoc, doc, query, orderBy, where } from "firebase/firestore";
import AdminHeader from "../components/AdminHeader";
import AdminSidebar from "../components/AdminSidebar";
import { useLanguage } from "../contexts/LanguageContext";
import "../styles/NotificationsPage.css";

const NotificationsPage = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userType, setUserType] = useState("restaurant"); // نوع المستخدم الافتراضي
  const { t } = useLanguage();

  useEffect(() => {
    // اختيار نوع المستخدم من localStorage (إذا كان مخزنًا)
    const savedUserRole = localStorage.getItem("userRole");
    if (savedUserRole) {
      setUserType(savedUserRole);
    }

    fetchNotifications();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userType]);

  // ✅ جلب الإشعارات من Firestore
  const fetchNotifications = async () => {
    try {
      setLoading(true);
      console.log("📌 جاري جلب الإشعارات...");
      
      // إنشاء استعلام يجلب الإشعارات المخصصة لنوع المستخدم الحالي
      const notificationsQuery = query(
        collection(db, "notifications"),
        where("recipientType", "==", userType),
        orderBy("timestamp", "desc")
      );
      
      const querySnapshot = await getDocs(notificationsQuery);

      if (querySnapshot.empty) {
        console.warn("⚠️ لا توجد إشعارات متاحة.");
        setNotifications([]);
      } else {
        const data = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
          // تحويل الطابع الزمني إلى تنسيق قابل للقراءة
          formattedDate: doc.data().timestamp ? new Date(doc.data().timestamp.toDate()).toLocaleString('ar-EG') : "غير متوفر"
        }));
        
        console.log("📌 الإشعارات المسترجعة:", data);
        setNotifications(data);
      }
    } catch (error) {
      console.error("❌ خطأ في جلب الإشعارات:", error.message);
    } finally {
      setLoading(false);
    }
  };

  // ✅ تحديث حالة الإشعار (مقروء/غير مقروء)
  const markAsRead = async (notificationId) => {
    try {
      await updateDoc(doc(db, "notifications", notificationId), { isRead: true });
      setNotifications((prev) =>
        prev.map((notification) =>
          notification.id === notificationId ? { ...notification, isRead: true } : notification
        )
      );
    } catch (error) {
      console.error("❌ خطأ في تحديث حالة الإشعار:", error.message);
    }
  };

  return (
    <div className="admin-reports-page" dir="rtl">
      <AdminSidebar />
      <div className="admin-reports-content">
        <AdminHeader title={t('notifications')} />
        
        <div style={{ textAlign: "center", marginTop: "50px", padding: "0 20px" }}>
          <h2>{t('notifications')}</h2>
          
          {/* عرض الإشعارات */}
          {loading ? (
            <div className="loading-spinner">
              <div className="spinner"></div>
              <p>{t('loading')}</p>
            </div>
          ) : notifications.length === 0 ? (
            <div className="no-notifications">
              <p>⚠️ {t('no_notifications')}</p>
            </div>
          ) : (
            <div className="notifications-list">
              {notifications.map((notification) => (
                <div
                  key={notification.id}
                  className={`notification-item ${notification.isRead ? 'read' : 'unread'}`}
                >
                  <button
                    onClick={() => markAsRead(notification.id)}
                    disabled={notification.isRead}
                    className={`mark-read-btn ${notification.isRead ? 'read' : 'unread'}`}
                  >
                    {notification.isRead ? t('read') : t('mark_as_read')}
                  </button>
                  
                  <div className="notification-content">
                    <div className="notification-message">
                      {notification.message}
                    </div>
                    <div className="notification-date">
                      {notification.formattedDate}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotificationsPage;